<div class="container">
  <div class="content">
    <div class="logo-section">
      <img class="logo" src="assets/icons/tc_logo.svg" alt="tc-logo" />
      <img *ngIf="platform" class="logo" src="assets/icons/vtex.svg" alt="platform-logo" />
    </div>

    <div class="title-section">
      <h1 class="title">{{ !forgotPassword ? 'Iniciá sesión' : 'Recuperá tu contraseña' }}</h1>
      <h3 class="subtitle">
        {{ !forgotPassword ? '¡Que lindo tenerte de vuelta!' : 'Te enviaremos un link a tu mail' }}
      </h3>
    </div>

    <div class="signin-form">
      <form [formGroup]="signInForm" class="form">
        <mat-form-field appearance="outline">
          <input
            placeholder="Email"
            matInput
            type="text"
            name="email"
            formControlName="emailControl"
          />
          <mat-error
            for="register-email"
            class="form-error"
            *ngIf="!signInForm.controls.pristine && signInForm.controls.emailControl.invalid"
          >
            {{ utils.getErrorMessage(signInForm.controls['emailControl'].errors) }}</mat-error
          >
        </mat-form-field>
        <mat-form-field appearance="outline" *ngIf="!forgotPassword">
          <input
            placeholder="Contraseña"
            matInput
            [type]="seePassword ? 'text' : 'password'"
            name="password"
            formControlName="passwordControl"
          />
          <img
            class="eye-icon"
            src="assets/icons/eye.svg"
            *ngIf="!seePassword"
            (click)="seePassword = true"
            alt="seePassword"
          />
          <img
            class="eye-off-icon"
            src="assets/icons/eye-off.svg"
            *ngIf="seePassword"
            (click)="seePassword = false"
            alt="seePassword"
          />
          <mat-error
            for="register-password"
            *ngIf="
              !signInForm.controls.passwordControl.pristine &&
              signInForm.controls.passwordControl.invalid
            "
          >
            {{ utils.getErrorMessage(signInForm.controls['passwordControl'].errors) }}
          </mat-error>
        </mat-form-field>
        <button
          class="td-btn primary"
          (click)="forgotPassword ? recoverPassword() : login()"
          [disabled]="loading"
        >
          {{ !forgotPassword ? 'Iniciar sesión' : 'Recuperar contraseña' }}
        </button>
      </form>
    </div>

    <div class="options">
      <div class="option">
        <p class="text" *ngIf="!loading" (click)="forgotPassword = !forgotPassword">
          {{ !forgotPassword ? 'Olvidé mi contraseña' : 'Recordé mi contraseña' }}
        </p>
      </div>
      <div class="option">
        <p class="text" *ngIf="!loading" (click)="openSignUpView()">
          ¿Aún no tenés cuenta? Registrate
        </p>
      </div>
    </div>

    <div class="signin-qr">
      <span class="signin-qr_border">O</span>
      <button class="signin-qr_button" (click)="signInQR()">
        <span>Iniciar sesión con código QR</span>
        <img src="/assets/images/qr.svg" alt="code_qr" />
      </button>
    </div>

    <div class="footer">
      <p class="text" (click)="utils.openTyc()">Términos y Condiciones</p>
      <p class="text">© TiendaCrypto {{ actualYear }}</p>
    </div>
  </div>
</div>
